import { toPng } from 'html-to-image';

/**
 * Captures a DOM element to PNG using html-to-image (supports Tailwind + gradients).
 * Falls back to download if Web Share API is unavailable.
 */
export async function captureAndShare(element, filename = 'trade.png') {
  await document.fonts.ready;

  const dataUrl = await toPng(element, {
    cacheBust: true,
    pixelRatio: 2,
    backgroundColor: '#08090f',
  });

  const res  = await fetch(dataUrl);
  const blob = await res.blob();
  const file = new File([blob], filename, { type: 'image/png' });

  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file] });
      return 'shared';
    } catch (err) {
      if (err.name === 'AbortError') return 'cancelled';
    }
  }

  // Fallback: download
  const url = URL.createObjectURL(blob);
  const a   = document.createElement('a');
  a.href     = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
  return 'downloaded';
}
